
import React from 'react'
import MobileGrid from './MobileGrid'
import { Box,  Typography } from '@mui/material'
import {
    Filter,
    List,
    TextInput,
    useTranslate,
    usePermissions,
    Pagination,
    useListContext
} from 'react-admin'
import { hasWriteAccess, PER_PAGE } from '../../../helper/resourceHelper'
import { useTheme, useMediaQuery } from '@mui/material'
import SearchInputLabelComponent from '../../../ui/inputs/SearchInputLabelComponent'
import { listCommonStyle, searchInputCommonStyle } from '../../../themes/commonStyles'
import { AddBtnWithOptionalMenu } from '../../../ui/button/AddBtn'
import Empty from './Empty'




const IntegrationTibibActions = ({
    isMobile
}) => {
    const { resource } = useListContext();
    const { isLoading, permissions } = usePermissions();
    const theme = useTheme();
    const translate = useTranslate();
    const addBtnMenuItems = []


    if (hasWriteAccess(permissions)) {
        addBtnMenuItems.push({
            label: translate('resources.hooks.create'),
            path: `/${resource}/create`
        })
    }

    
    return (
        <Box sx={{
            display: "flex",
            flexDirection: "row"

        }}>

            <AddBtnWithOptionalMenu menuItems={addBtnMenuItems} isMobile={isMobile} />
        </Box>
    )



}




const IntegrationTibibPagination = ({ cardMode }) => {
    const theme = useTheme()

    return (<Pagination sx={{
        '& .MuiToolbar-root': {
            borderTopRightRadius: cardMode ? "12px" : "0px",
            borderTopLeftRadius: cardMode ? "12px" : "0px",
            borderBottomRightRadius: "12px",
            borderBottomLeftRadius: "12px",
            marginTop: cardMode ? "25px" : "0px",

        }

    }} rowsPerPageOptions={[10, 25, 50, 100, 500]} />)
};



const IntegrationTibibList = (props) => {
    const translate = useTranslate();
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
    return (

        <Box >
           <Typography color="text.main" sx={{
                fontFamily: "Roboto",
                fontSize: "16px",
                fontWeight: 700,
                lineHeight: "25px",
                textAlign: "start",
                margin: "30px 0px 10px 0px"
            }}
            >
                {translate('resources.integrations.list_sections.tibib')}
            </Typography>
            <List

                title={translate('resources.integrations.name', { smart_count: 2 })}
                actions={<IntegrationTibibActions isMobile={isSmall} />}
                empty={<Empty
                    btnLabel={translate('resources.integrations.create_new_tibib_integration')}
                    message={translate('resources.integrations.empty_tibib_integrations')}
                    subMessage={translate('resources.integrations.click_below_to_create_new_tibib_integration')}
                />}
                filters={!isSmall ?
                    <Filter {...props}>

                        <TextInput
                            id="outlined-basic-size-small"
                            label={<SearchInputLabelComponent />}
                            source="q"
                            alwaysOn
                            sx={searchInputCommonStyle({ theme, isSmall: isSmall })}
                        />
                    </Filter> : null
                }
                sort={{ field: 'name', order: 'ASC' }}
                perPage={PER_PAGE}
                pagination={false}
                sx={listCommonStyle({ isCardMode: true, theme, isSmall })}
                resource='integrations_tibib'
            >
                <MobileGrid isSmall={isSmall} />

                <IntegrationTibibPagination cardMode={true} />

            </List>
            
        </Box>
    )
}


export default IntegrationTibibList

